var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCheckboxGen = function SvgIconCheckboxGen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-checkbox-gen_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#F8DFD8",
    rx: 5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    fillRule: "evenodd",
    d: "M14.797 6.548c.42.42.42 1.102 0 1.522l-5.382 5.382c-.42.42-1.101.42-1.522 0l-2.69-2.69a1.076 1.076 0 0 1 1.522-1.523l1.93 1.93 4.62-4.62c.42-.421 1.102-.421 1.522 0",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-checkbox-gen_svg__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#fff",
    rx: 5
  })))));
};
export default SvgIconCheckboxGen;